/* CANIPANI — Recherche prédictive (API Shopify native, sans dépendance) */

(function () {
  'use strict';

  var form = document.querySelector('[data-predictive-search]');
  if (!form) return;

  var input = form.querySelector('input[type="search"]');
  var results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  var controller = null;
  var timer = null;

  function render(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-predictive-results]');
    results.innerHTML = fresh ? fresh.innerHTML : '';
    results.hidden = false;
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,page&resources[limit]=6' +
      '&section_id=predictive-search';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(render)
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    window.clearTimeout(timer);
    if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
    timer = window.setTimeout(function () { search(term); }, 220);
  });
})();
